import { render } from "./receipt.vue?vue&type=template&id=3c329cf8&scoped=true"
import script from "./receipt.vue?vue&type=script&lang=js"
export * from "./receipt.vue?vue&type=script&lang=js"

import "./receipt.vue?vue&type=style&index=0&id=3c329cf8&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c329cf8"]])

export default __exports__